// 圆角条形样式复用原进度条实例与已解析的 dataChart，不增加独立数据请求。
const finite = (value, fallback) => ['number', 'string'].includes(typeof value) && String(value).trim() !== '' && Number.isFinite(Number(value)) ? Number(value) : fallback
const bounded = (value, fallback, min, max) => Math.max(min, Math.min(max, finite(value, fallback)))
const color = (value, fallback) => typeof value === 'string' && /^(?:#(?:[a-f\d]{3}|[a-f\d]{4}|[a-f\d]{6}|[a-f\d]{8})|(?:rgb|hsl)a?\([\d\s.,%+/-]+\)|transparent|white|black)$/i.test(value) ? value : fallback

export function progressPresentationSettings (option = {}) {
  return {
    height: bounded(option.progressHeight, 14, 2, 80),
    fontSize: bounded(option.progressFontSize, 18, 8, 100),
    gap: bounded(option.progressGap, 8, 0, 100),
    precision: Math.round(bounded(option.progressPrecision, 1, 0, 6)),
    startColor: color(option.progressStartColor, '#13cfff'),
    endColor: color(option.progressEndColor, '#2695ff'),
    trackColor: color(option.progressTrackColor, '#123761'),
    textColor: color(option.progressTextColor, '#8abfe9'),
    fontFamily: typeof option.fontFamily === 'string' && option.fontFamily ? option.fontFamily : 'Microsoft YaHei',
    fontWeight: option.fontWeight || '600'
  }
}

export function progressReading (data = {}, option = {}) {
  // 原 Avue 的百分比字段是 data；value 仅在没有 data 字段时兼容普通数值数据源。
  const raw = Object.prototype.hasOwnProperty.call(data || {}, 'data') ? data.data : data && data.value
  const value = finite(raw, null), settings = progressPresentationSettings(option)
  return { value, percent: value === null ? 0 : Math.max(0, Math.min(100, value)),
    text: value === null ? '—' : value.toLocaleString('zh-CN', { minimumFractionDigits: settings.precision, maximumFractionDigits: settings.precision }) + '%' }
}

export function progressPresentationStyles (option = {}) {
  const settings = progressPresentationSettings(option)
  return {
    root: { width: '100%', height: '100%', boxSizing: 'border-box', display: 'flex', alignItems: 'center', columnGap: settings.gap + 'px', overflow: 'hidden', background: 'transparent', fontFamily: settings.fontFamily },
    track: { position: 'relative', flex: '1 1 0', minWidth: '0', height: settings.height + 'px', maxHeight: '100%', overflow: 'hidden', borderRadius: '999px', background: settings.trackColor },
    fill: { height: '100%', borderRadius: 'inherit', background: 'linear-gradient(90deg, ' + settings.startColor + ', ' + settings.endColor + ')', boxShadow: 'inset 0 1px 0 rgba(255,255,255,.15)' },
    value: { flex: '0 1 auto', maxWidth: '60%', minWidth: '0', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: settings.textColor, fontSize: settings.fontSize + 'px', lineHeight: '1.2', fontWeight: settings.fontWeight, fontVariantNumeric: 'tabular-nums' }
  }
}

function progressContent (vm, h) {
  const option = vm.option || {}, reading = progressReading(vm.dataChart, option), styles = progressPresentationStyles(option)
  return h('div', { class: 'screen-progress', style: styles.root,
    attrs: { role: 'progressbar', 'aria-label': '进度', 'aria-valuemin': 0, 'aria-valuemax': 100, 'aria-valuenow': reading.value === null ? undefined : reading.percent, 'aria-valuetext': reading.text } }, [
    h('div', { class: 'screen-progress__track', style: styles.track, attrs: { 'aria-hidden': 'true' } }, [
      h('div', { class: 'screen-progress__fill', style: { ...styles.fill, width: reading.percent + '%' } })
    ]),
    h('span', { class: 'screen-progress__value', style: styles.value, attrs: { title: reading.text } }, [reading.text])
  ])
}

export function installProgressPresentation (Vue) {
  if (Vue.__progressPresentation) return
  Vue.__progressPresentation = true
  Vue.mixin({ beforeCreate () {
    if (this.$options.name !== 'avue-echart-progress' || !this.$options.render) return
    const original = this.$options.render
    this.$options.render = function (...args) {
      const node = original.apply(this, args)
      if (!node || !this.option || this.option.progressStyle !== 'tech' || this.option.type === 'circle') return node
      node.children = [progressContent(this, args[0] || this.$createElement)]
      return node
    }
  } })
}

export function createTechProgress () {
  return { label: '圆角进度条', cover: 'ui/rounded-progress.svg', option: {
    title: '圆角进度条', name: '圆角进度条', icon: 'icon-progress', top: 0, left: 0,
    dataType: 0, data: { data: 68.9 }, dataFormatter: '', dataScript: '',
    component: { width: 340, height: 32, name: 'progress', prop: 'progress' },
    option: { type: 'line', progressStyle: 'tech', progressHeight: 14, progressFontSize: 18, progressGap: 8, progressPrecision: 1,
      progressStartColor: '#13cfff', progressEndColor: '#2695ff', progressTrackColor: '#123761', progressTextColor: '#8abfe9' }
  } }
}
